import Section from "../../common/section";

const RelaseNotes = () => {
  return (
    <Section title="release_notes" className="edexlms-page-body release-notes">
      <div className="flex flex-column gap-4">
        <div className="release-notes-section">
          <div className="text-lg mb-2">
            <strong>v3.0.0 - Major release</strong> - 09 October 2026
          </div>
          <ul>
            <li style={{ margin: "8px 0" }}>
              Optional training
              <ul>
                <li style={{ margin: "5px 0" }}>
                  Learning programs can be assigned as Required or Optional;
                  optional training has no due date
                </li>
                <li style={{ margin: "5px 0" }}>
                  Optional training is labelled for learners and admins and is
                  never shown as overdue
                </li>
                <li style={{ margin: "5px 0" }}>
                  Reminder and overdue emails are sent for required training
                  only
                </li>
                <li style={{ margin: "5px 0" }}>
                  Reports have a Training type filter (Required, Optional, All)
                </li>
              </ul>
            </li>
            <li style={{ margin: "8px 0" }}>
              Saved and scheduled reports
              <ul>
                <li style={{ margin: "5px 0" }}>
                  Save a report with its filters and open it again later
                </li>
                <li style={{ margin: "5px 0" }}>
                  Schedule a saved report weekly or monthly in your time zone;
                  it arrives by email as a download link to the Excel, PDF or
                  CSV file, valid for 7 days
                </li>
                <li style={{ margin: "5px 0" }}>
                  Send history kept for 90 days
                </li>
              </ul>
            </li>
            <li style={{ margin: "8px 0" }}>
              Employee data loading
              <ul>
                <li style={{ margin: "5px 0" }}>
                  Uploads run in the background with row-by-row results and an
                  upload history kept for 90 days
                </li>
                <li style={{ margin: "5px 0" }}>
                  Blank cells leave the stored value unchanged
                </li>
                <li style={{ margin: "5px 0" }}>
                  Status accepts any letter case; the Manager column accepts a
                  username or an email
                </li>
                <li style={{ margin: "5px 0" }}>
                  The welcome email follows the notification switch, with its
                  own wording for single sign-on users
                </li>
              </ul>
            </li>
            <li style={{ margin: "8px 0" }}>
              Certificate downloads (Reports &gt; Certificate downloads)
              <ul>
                <li style={{ margin: "5px 0" }}>
                  Download certificates for one item, several items or all
                  training, filtered by audience and completion dates
                </li>
                <li style={{ margin: "5px 0" }}>
                  One ZIP with a folder per learner, up to 2,000 certificates
                  per download, and an email when it is ready
                </li>
              </ul>
            </li>
            <li style={{ margin: "8px 0" }}>
              Audit logs
              <ul>
                <li style={{ margin: "5px 0" }}>
                  See who changed what, with sign-ins, learning activity,
                  exports and downloads, filter it and export it, for people
                  with access to Settings. Entries are kept for 1 year
                </li>
              </ul>
            </li>
            <li style={{ margin: "8px 0" }}>
              Company sign-in and MFA
              <ul>
                <li style={{ margin: "5px 0" }}>
                  People can sign in with their company account through SAML
                  2.0 or OpenID Connect; SysRoot users set it up under
                  Settings &gt; Enterprise &gt; Company sign-in and can test it
                  before switching it on
                </li>
                <li style={{ margin: "5px 0" }}>
                  Password sign-in can be switched off, and the sign-in page
                  then goes straight to your company sign-in
                </li>
                <li style={{ margin: "5px 0" }}>
                  Users are Local or SSO, chosen on the add form, the profile
                  and the upload file
                </li>
                <li style={{ margin: "5px 0" }}>
                  Require MFA for Local users: a code from an authenticator app
                  after the password; an admin can reset a lost authenticator
                  from the user's profile
                </li>
              </ul>
            </li>
            <li style={{ margin: "8px 0" }}>
              Enterprise settings
              <ul>
                <li style={{ margin: "5px 0" }}>
                  SMTP username and password are kept when left blank
                </li>
                <li style={{ margin: "5px 0" }}>
                  Reset to default on the SMTP tab removes your organisation's
                  SMTP settings, and email then goes out with the application's
                  default settings
                </li>
              </ul>
            </li>
            <li style={{ margin: "8px 0" }}>
              Important for administrators
              <ul>
                <li style={{ margin: "5px 0" }}>
                  The "Program assigned" and "User creation" email templates
                  were updated in every language; re-apply any custom wording
                  after the update
                </li>
                <li style={{ margin: "5px 0" }}>
                  Two new emails for SysRoot users, "Company sign-in
                  certificate expiring" and "Emergency sign-in used", can be
                  switched off on the Notifications screen
                </li>
              </ul>
            </li>
            <li style={{ margin: "8px 0" }}>
              Fixes
              <ul>
                <li style={{ margin: "5px 0" }}>
                  Certificate logos load reliably and wide logos fit the
                  certificate
                </li>
                <li style={{ margin: "5px 0" }}>
                  Learners are no longer enrolled twice in the same program
                </li>
                <li style={{ margin: "5px 0" }}>
                  Completing a program no longer creates a duplicate enrolment
                  in the next program
                </li>
                <li style={{ margin: "5px 0" }}>
                  Saved report titles display correctly
                </li>
                <li style={{ margin: "5px 0" }}>
                  Mark As Completed on a user's pending assignments asks for
                  the completion date (today by default); the program and the
                  certificate show that date
                </li>
                <li style={{ margin: "5px 0" }}>
                  The certificate a learner opens shows the same completion
                  date as downloaded certificates
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div className="release-notes-section">
          <div className="text-lg mb-2">
            <strong>v2.0.0 – Major release</strong> - 27 August 2025
          </div>
          <ul>
            <li style={{ margin: "8px 0" }}>
              LongText field type added to Custom Fields for extended text input
            </li>
            <li style={{ margin: "8px 0" }}>
              Conditional Custom Fields enabling dynamic form behavior based on
              user selections
            </li>
            <li style={{ margin: "8px 0" }}>
              Self Registration configuration section in Enterprise settings
            </li>
            <li style={{ margin: "8px 0" }}>
              Complete Self Registration flow allowing users to create accounts
              independently
            </li>
            <li style={{ margin: "8px 0" }}>
              Google Forms integration as a new Learning Object type
            </li>
            <li style={{ margin: "8px 0" }}>
              New Integration management menu with Google Analytics tracking
              support
            </li>
          </ul>
        </div>
        <div className="release-notes-section">
          <div className="text-lg mb-2">
            <strong>v1.4.0 – Minor release</strong> - 28 July 2025
          </div>
          <ul>
            <li style={{ margin: "8px 0" }}>
              Learning Objects Reports - Assessment % for Scorm Objects
            </li>
            <li style={{ margin: "8px 0" }}>
              Simplified Login Process Enabling Quick Access with Password or
              OTP
            </li>
            <li style={{ margin: "8px 0" }}>
              Forced Changed Password Flow now only triggers when a user signs
              in for the first time using a password
            </li>
          </ul>
        </div>
        <div className="release-notes-section">
          <div className="text-lg mb-2">
            <strong>v1.3.0 – Minor release</strong> - 14 June 2025
          </div>
          <ul>
            <li style={{ margin: "8px 0" }}>Release Notes</li>
            <li style={{ margin: "8px 0" }}>
              Minor Fixes
              <ul>
                <li style={{ margin: "5px 0" }}>Login Page Message Display</li>
                <li style={{ margin: "5px 0" }}>
                  Learning Program Linear Progression
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div className="release-notes-section">
          <div className="text-lg mb-2">
            <strong>v1.2.0 – Minor release</strong> - 23 May 2025
          </div>
          <ul>
            <li style={{ margin: "8px 0" }}>
              User Export & Import formats aligned so the same file format can
              be used
            </li>
            <li style={{ margin: "8px 0" }}>
              Learning Plan assignments enhancements:
              <ul>
                <li style={{ margin: "5px 0" }}>
                  Time zone support added to Learning Plan assignments
                </li>
                <li style={{ margin: "5px 0" }}>
                  Assignment & reminder emails now account for the assignment
                  time zone
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div className="release-notes-section">
          <div className="text-lg mb-2">
            <strong>v1.1.0 – Minor release</strong> - 01 May 2025
          </div>
          <ul>
            <li style={{ margin: "8px 0" }}>
              Multi-lingual support for notifications
            </li>
            <li style={{ margin: "8px 0" }}>Cohort users view and export</li>
            <li style={{ margin: "8px 0" }}>
              Preferred language selection for Enterprise & user-level
            </li>
            <li style={{ margin: "8px 0" }}>
              Notifications in selected languages (6 pre-specified)
            </li>
            <li style={{ margin: "8px 0" }}>
              Reports enhancements
              <ul>
                <li style={{ margin: "5px 0" }}>
                  Displaying status of optional objects
                </li>
                <li style={{ margin: "5px 0" }}>
                  Ability to see reports for inactive users
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div className="release-notes-section">
          <div className="text-lg mb-2">
            <strong>v1.0.0 – Major release</strong> - 03 March 2025
          </div>
          <div style={{ margin: "10px 0" }}>
            System released with core funtionality: 
          </div>
          <ul>
            <li style={{ margin: "8px 0" }}>User administration</li>
            <li style={{ margin: "8px 0" }}>User profile custom fields</li>
            <li style={{ margin: "8px 0" }}>Role management</li>
            <li style={{ margin: "8px 0" }}>Learning management</li>
            <li style={{ margin: "8px 0" }}>Learning assignment</li>
            <li style={{ margin: "8px 0" }}>Dynamic cohorts</li>
            <li style={{ margin: "8px 0" }}>Notifications (specified)</li>
            <li style={{ margin: "8px 0" }}>Reports (specified)</li>
            <li style={{ margin: "8px 0" }}>
              Enterprise management
              <ul>
                <li style={{ margin: "5px 0" }}>Theming</li>
                <li style={{ margin: "5px 0" }}>SMTP</li>
                <li style={{ margin: "5px 0" }}>Email templates</li>
                <li style={{ margin: "5px 0" }}>Learning dashboards</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </Section>
  );
};

export default RelaseNotes;
